import { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project-imports
// import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';
import { useLazyMeQuery } from 'api/auth';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useDispatch } from 'react-redux';
import { useLazyGetUserCustomerSettingsQuery } from 'api/userCustomerSettings';
import { GetUserCustomSettings } from '../user-settings';
import { useUserSettings } from '../../hooks/useUserSettings';
import { SetAllUserSettings } from '../../store/reducers/userSettingsSlice';
// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const decodedAuthToken = useSelector((state: RootState) => state.auth.decodedAuthToken);
  const [init, setIsInit] = useState<boolean>(false);
  const [fetchMeInfo] = useLazyMeQuery();
  const [fetchUserSetting] = useLazyGetUserCustomerSettingsQuery();
  const { SetUserSetting, isUserSettingsInitialized } = useUserSettings();
  const dispatch = useDispatch();

  const initToken = useCallback(async () => {
    if (!init && !decodedAuthToken) {
      try {
        // eslint-disable-next-line eqeqeq
        if (localStorage.getItem('isLoggedOut') == 'true') throw new Error('Forced Lgout');
        await fetchMeInfo().unwrap();
        try {
          if (!isUserSettingsInitialized) {
            const userSettinData = await fetchUserSetting().unwrap();
            if (userSettinData) {
              await SetUserSetting(userSettinData);
            }
          }
        } catch (error) {}
      } catch (error) {
        if (error) {
          navigate('/login', {
            state: {
              from: location.pathname
            },
            replace: true
          });
        }
      } finally {
        setIsInit(true);
      }
    }
  }, [init, fetchMeInfo, navigate, location.pathname, decodedAuthToken]);

  useEffect(() => {
    initToken();
  }, [initToken]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if ((init && !decodedAuthToken) || localStorage.getItem('isLoggedOut') == 'true') {
      navigate('/login', {
        state: {
          from: location.pathname
        },
        replace: true
      });
    }
  }, [init, decodedAuthToken, navigate, location.pathname]);

  useEffect(() => {
    const sessionData = GetUserCustomSettings();
    dispatch(SetAllUserSettings(sessionData));
  }, []);

  return children;
};

export default AuthGuard;
